import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_load_containers_grid_ComponentContextService } from './FootprintManager.load_containers_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { LoadContainers_load_container_date_types_singleComponent } from './LoadContainers.load_container_date_types_single.component'


interface IFootprintManager_load_containers_gridComponentEntity {
  Id?: number, AvailableDate?: string, CallOutDate?: string, CheckOutDate?: string, ContainerSize?: string, ContainsPortalVisibleAttachments?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, InYardDate?: string, LastOnsiteDate?: string, LastPierDate?: string, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, Priority?: number, ReasonCodeId?: number, SealIdentifier?: string, TrailerNumber?: string, Carrier?: { Id?: number, Name?: string }, CarrierServiceType?: { Id?: number, Name?: string }, ContainerType?: { Id?: number, Name?: string }, OrderType?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string }, YardLocation?: { Id?: number, Name?: string }, DockAppointmentsLoadContainersLookup?: { DockAppointmentId?: number, DockAppointment?: { LookupCode?: string, ScheduledLocation?: { Name?: string } } }[]}

interface IFootprintManager_load_containers_gridComponentInParams {
  statusIds?: number[], ownerId?: number, orderTypeIds?: number[]}


class FootprintManager_load_containers_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_load_containers_gridComponent;
  entity: IFootprintManager_load_containers_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    LookupCode: null,
    OrderType_Name: null,
    Available: null,
    Picked: null,
    Loaded: null,
    Received: null,
    Putaway: null,
    Status_Name: null,
    ContainerType_Name: null,
    Carrier_Name: null,
    CarrierServiceType_Name: null,
    Priority: null,
    ContainerSize: null,
    DockAppointment: null,
    ScheduledLocation: null,
    SealIdentifier: null,
    TrailerNumber: null,
    YardLocation_Name: null,
    Notes: null,
    AvailableDate: null,
    CallOutDate: null,
    CheckOutDate: null,
    InYardDate: null,
    LastOnsiteDate: null,
    LastPierDate: null,
    CreatedSysDateTime: null,
    CreatedSysUser: null,
    ModifiedSysDateTime: null,
    ModifiedSysUser: null,
  }



  constructor(
    grid: FootprintManager_load_containers_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_load_containers_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.LookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OrderType_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OrderType_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Available = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Available,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Picked = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Picked,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Loaded = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Loaded,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Received = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Received,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Putaway = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Putaway,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Status_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Status_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ContainerType_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ContainerType_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Carrier_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Carrier_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CarrierServiceType_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CarrierServiceType_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Priority = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Priority,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ContainerSize = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ContainerSize,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.DockAppointment = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.DockAppointment,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ScheduledLocation = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ScheduledLocation,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SealIdentifier = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SealIdentifier,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.TrailerNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.TrailerNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.YardLocation_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.YardLocation_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AvailableDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AvailableDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CallOutDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CallOutDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CheckOutDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CheckOutDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.InYardDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.InYardDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LastOnsiteDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LastOnsiteDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LastPierDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LastPierDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedSysDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedSysDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedSysUser = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedSysUser,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedSysDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedSysDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedSysUser = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedSysUser,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_load_containers_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_load_containers_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      ownerId:  $grid.inParams.ownerId ,
      dateType:  $grid.filters.date_type.control.value ,
      orderTypeIds:  $grid.inParams.orderTypeIds ,
      take:  null ,
      skip:  null ,
      lookupCode:  null ,
    };
    const data = await this.$datasources.LoadContainers.ds_load_containers_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_load_containers_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.LookupCode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.OrderType_Name.displayControl as TextModel).text = $row.entity.OrderType?.Name;
    (this.cells.Status_Name.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.ContainerType_Name.displayControl as TextModel).text = $row.entity.ContainerType?.Name;
    (this.cells.Carrier_Name.displayControl as TextModel).text = $row.entity.Carrier?.Name;
    (this.cells.CarrierServiceType_Name.displayControl as TextModel).text = $row.entity.CarrierServiceType?.Name;
    (this.cells.Priority.displayControl as TextModel).text = $row.entity.Priority?.toString();
    (this.cells.ContainerSize.displayControl as TextModel).text = $row.entity.ContainerSize;
    (this.cells.DockAppointment.displayControl as TextModel).text = $row.entity.DockAppointmentsLoadContainersLookup[0]?.DockAppointment?.LookupCode;
    (this.cells.ScheduledLocation.displayControl as TextModel).text = $row.entity.DockAppointmentsLoadContainersLookup[0]?.DockAppointment?.ScheduledLocation?.Name;
    (this.cells.SealIdentifier.displayControl as TextModel).text = $row.entity.SealIdentifier;
    (this.cells.TrailerNumber.displayControl as TextModel).text = $row.entity.TrailerNumber;
    (this.cells.YardLocation_Name.displayControl as TextModel).text = $row.entity.YardLocation?.Name;
    (this.cells.Notes.displayControl as TextModel).text = $row.entity.Notes;
    (this.cells.AvailableDate.displayControl as TextModel).text = $row.entity.AvailableDate?.toString();
    (this.cells.CallOutDate.displayControl as TextModel).text = $row.entity.CallOutDate?.toString();
    (this.cells.CheckOutDate.displayControl as TextModel).text = $row.entity.CheckOutDate?.toString();
    (this.cells.InYardDate.displayControl as TextModel).text = $row.entity.InYardDate?.toString();
    (this.cells.LastOnsiteDate.displayControl as TextModel).text = $row.entity.LastOnsiteDate?.toString();
    (this.cells.LastPierDate.displayControl as TextModel).text = $row.entity.LastPierDate?.toString();
    (this.cells.CreatedSysDateTime.displayControl as TextModel).text = $row.entity.CreatedSysDateTime?.toString();
    (this.cells.CreatedSysUser.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.ModifiedSysDateTime.displayControl as TextModel).text = $row.entity.ModifiedSysDateTime?.toString();
    (this.cells.ModifiedSysUser.displayControl as TextModel).text = $row.entity.ModifiedSysUser;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'LookupCode' : {
        this.on_lookup_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_load_containers_gridComponentRowModel,
  $grid: FootprintManager_load_containers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // O.Arias 07/11/2023
  
  // Set Date/Time Formats
  const format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  if ($utils.isDefined(format)) {
  
      if ($utils.isDefined($row.entity.AvailableDate)) {
          $row.cells.AvailableDate.displayControl.text = $utils.date.format($row.entity.AvailableDate, format);
      };
  
      if ($utils.isDefined($row.entity.CallOutDate)) {
          $row.cells.CallOutDate.displayControl.text = $utils.date.format($row.entity.CallOutDate, format);
      };
  
      if ($utils.isDefined($row.entity.CheckOutDate)) {
          $row.cells.CheckOutDate.displayControl.text = $utils.date.format($row.entity.CheckOutDate, format);
      };
  
      if ($utils.isDefined($row.entity.CreatedSysDateTime)) {
          $row.cells.CreatedSysDateTime.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.InYardDate)) {
          $row.cells.InYardDate.displayControl.text = $utils.date.format($row.entity.InYardDate, format);
      };
  
      if ($utils.isDefined($row.entity.LastOnsiteDate)) {
          $row.cells.LastOnsiteDate.displayControl.text = $utils.date.format($row.entity.LastOnsiteDate, format);
      };
  
      if ($utils.isDefined($row.entity.LastPierDate)) {
          $row.cells.LastPierDate.displayControl.text = $utils.date.format($row.entity.LastPierDate, format);
      };
  
      if ($utils.isDefined($row.entity.ModifiedSysDateTime)) {
          $row.cells.ModifiedSysDateTime.displayControl.text = $utils.date.format($row.entity.ModifiedSysDateTime, format);
      };
  
  };
  }
  on_lookup_clicked(event = null) {
    return this.on_lookup_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookup_clickedInternal(
    $row: FootprintManager_load_containers_gridComponentRowModel,
  $grid: FootprintManager_load_containers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  /* On id clicked */
  
  $shell.FootprintManager.openload_container_editor({ loadContainerId: $row.entity.Id });
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => LoadContainers_load_container_date_types_singleComponent),
  ],
  selector: 'FootprintManager-load_containers_grid',
  templateUrl: './FootprintManager.load_containers_grid.component.html'
})
export class FootprintManager_load_containers_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_load_containers_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_load_containers_gridComponentInParams = { statusIds: [], ownerId: null, orderTypeIds: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'LookupCode', 'Container', false, false, null, false),       OrderType_Name: new GridHeaderModel(new HeaderStyles(null, null), 'OrderType_Name', 'Order type', false, false, null, false),       Available: new GridHeaderModel(new HeaderStyles(null, null), 'Available', 'Available %', false, false, null, false),       Picked: new GridHeaderModel(new HeaderStyles(null, null), 'Picked', 'Picked %', false, false, null, false),       Loaded: new GridHeaderModel(new HeaderStyles(null, null), 'Loaded', 'Loaded %', false, false, null, false),       Received: new GridHeaderModel(new HeaderStyles(null, null), 'Received', 'Received %', false, false, null, false),       Putaway: new GridHeaderModel(new HeaderStyles(null, null), 'Putaway', 'Putaway %', false, false, null, false),       Status_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Status_Name', 'Status', false, false, null, false),       ContainerType_Name: new GridHeaderModel(new HeaderStyles(null, null), 'ContainerType_Name', 'Container type', false, false, null, false),       Carrier_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Carrier_Name', 'Carrier', false, false, null, false),       CarrierServiceType_Name: new GridHeaderModel(new HeaderStyles(null, null), 'CarrierServiceType_Name', 'Service type', false, false, null, false),       Priority: new GridHeaderModel(new HeaderStyles(null, null), 'Priority', 'Priority', false, false, null, false),       ContainerSize: new GridHeaderModel(new HeaderStyles(null, null), 'ContainerSize', 'Container size', false, false, null, false),       DockAppointment: new GridHeaderModel(new HeaderStyles(null, null), 'DockAppointment', 'Dock appointment', false, false, null, false),       ScheduledLocation: new GridHeaderModel(new HeaderStyles(null, null), 'ScheduledLocation', 'Scheduled location', false, false, null, false),       SealIdentifier: new GridHeaderModel(new HeaderStyles(null, null), 'SealIdentifier', 'Seal ID', false, false, null, false),       TrailerNumber: new GridHeaderModel(new HeaderStyles(null, null), 'TrailerNumber', 'Trailer number', false, false, null, false),       YardLocation_Name: new GridHeaderModel(new HeaderStyles(null, null), 'YardLocation_Name', 'Yard location', false, false, null, false),       Notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', 'Notes', false, false, null, false),       AvailableDate: new GridHeaderModel(new HeaderStyles(null, null), 'AvailableDate', 'Available date', false, false, null, false),       CallOutDate: new GridHeaderModel(new HeaderStyles(null, null), 'CallOutDate', 'Call out date', false, false, null, false),       CheckOutDate: new GridHeaderModel(new HeaderStyles(null, null), 'CheckOutDate', 'Check out date', false, false, null, false),       InYardDate: new GridHeaderModel(new HeaderStyles(null, null), 'InYardDate', 'In yard date', false, false, null, false),       LastOnsiteDate: new GridHeaderModel(new HeaderStyles(null, null), 'LastOnsiteDate', 'Last onsite date', false, false, null, false),       LastPierDate: new GridHeaderModel(new HeaderStyles(null, null), 'LastPierDate', 'Last pier date', false, false, null, false),       CreatedSysDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedSysDateTime', 'Created date', false, false, null, false),       CreatedSysUser: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedSysUser', 'Created by', false, false, null, false),       ModifiedSysDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedSysDateTime', 'Modified date', false, false, null, false),       ModifiedSysUser: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedSysUser', 'Modified by', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_load_containers_gridComponentRowModel[] = [];

  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('orderTypeIds') set $inParams_orderTypeIds(value: any) {
    this.inParams['orderTypeIds'] = value;
  }
  get $inParams_orderTypeIds(): any {
    return this.inParams['orderTypeIds'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date from', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date to', false, false),
    date_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_type'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_load_containers_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Load containers';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      ownerId:  $grid.inParams.ownerId ,
      dateType:  $grid.filters.date_type.control.value ,
      orderTypeIds:  $grid.inParams.orderTypeIds ,
      take:  null ,
      skip:  null ,
      lookupCode:  null ,
    };
    try {
      const data = await this.$datasources.LoadContainers.ds_load_containers_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_load_containers_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_load_containers_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_load_containers_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: FootprintManager_load_containers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias 07/11/2023
  //Sandeep Export Grid modifications 12/08/2023
  
  const exportLimit = $settings.FootprintManager.ExcelExportLimit
  const dtstr = $utils.date.format(new Date().toString(), "MMDDYYYY-HHmm");
  
  // Initialize
  var wb = $event;
  var transactions = [];
  var allData: any[] = [];
  
  let dateFormat = $settings.FootprintManager.DateFormat ?? "MM/dd/yyyy";
  
  try {
      if ($grid.selectedRows.length > 0) {
          // Compile all data into JSON
          for (let row of $grid.selectedRows) {
  
              transactions.push({
                  "Id": row.entity.Id,
                  "Lookup code": row.entity.LookupCode,
                  "Order type": row.entity.OrderType?.Name,
                  "Status": row.entity.Status?.Name,
                  "Container type": row.entity.ContainerType?.Name,
                  "Carrier": row.entity.Carrier?.Name,
                  "Service type": row.entity.CarrierServiceType?.Name,
                  "Priority": row.entity.Priority?.toString(),
                  "Container size": row.entity.ContainerSize,
                  "Dock appointment": row.entity.DockAppointmentsLoadContainersLookup[0]?.DockAppointment?.LookupCode,
                  "Scheduled location": row.entity.DockAppointmentsLoadContainersLookup[0]?.DockAppointment?.ScheduledLocation?.Name,
                  "Seal id": row.entity.SealIdentifier,
                  "Trailer number": row.entity.TrailerNumber,
                  "Yard location": row.entity.YardLocation?.Name,
                  "Notes": row.entity.Notes,
                  "Available date": row.entity.AvailableDate?.toString(),
                  "Call out date": row.entity.CallOutDate?.toString(),
                  "Check out date": row.entity.CheckOutDate?.toString(),
                  "In yard date": row.entity.InYardDate?.toString(),
                  "Last onsite date": row.entity.LastOnsiteDate?.toString(),
                  "Last pier date": row.entity.LastPierDate?.toString(),
                  "Created date": row.entity.CreatedSysDateTime?.toString(),
                  "Created by": row.entity.CreatedSysUser,
                  "Modified date": row.entity.ModifiedSysDateTime?.toString(),
                  "Modified by": row.entity.ModifiedSysUser
  
              });
          }
          var ws = $utils.excel.json_to_sheet(transactions);
          $utils.excel.book_append_sheet(wb, ws, "LoadContainersExp_" + dtstr);
      } else {
          var totalRecords = (await $datasources.LoadContainers.ds_load_containers_grid.get({
              ownerId: $grid.inParams.ownerId,
              statusIds: $grid.inParams.statusIds,
              orderTypeIds: $grid.inParams.orderTypeIds,
              fromDate: $grid.filters.date_from.control.value,
              toDate: $grid.filters.date_to.control.value,
              dateType: $grid.filters.date_type.control.value,
              take: 1
          })).totalCount
  
          if (totalRecords > exportLimit) {
              (await $shell.Inventory.openInfoDialog(`Export limitation of ${exportLimit} exceeded`, `Excel will only export the first ${exportLimit} records`));
          }
          // Get all data from datasource
          var responseDetails = await $datasources.LoadContainers.ds_load_containers_grid.get({
              ownerId: $grid.inParams.ownerId,
              statusIds: $grid.inParams.statusIds,
              orderTypeIds: $grid.inParams.orderTypeIds,
              fromDate: $grid.filters.date_from.control.value,
              toDate: $grid.filters.date_to.control.value,
              dateType: $grid.filters.date_type.control.value,
              take: exportLimit
          });
  
          allData = allData.concat(responseDetails.result);
  
          // Compile all data into JSON
          for (let record of allData) {
              transactions.push({
                  "Lookup code": record.LookupCode,
                  "Order type": record.OrderType?.Name,
                  "Status": record.Status?.Name,
                  "Container type": record.ContainerType?.Name,
                  "Carrier": record.Carrier?.Name,
                  "Service type": record.CarrierServiceType?.Name,
                  "Priority": record.Priority?.toString(),
                  "Container size": record.ContainerSize,
                  "Dock appointment": record.DockAppointmentsLoadContainersLookup[0]?.DockAppointment?.LookupCode,
                  "Scheduled location": record.DockAppointmentsLoadContainersLookup[0]?.DockAppointment?.ScheduledLocation?.Name,
                  "Seal id": record.SealIdentifier,
                  "Trailer number": record.TrailerNumber,
                  "Yard location": record.YardLocation?.Name,
                  "Notes": record.Notes
              });
          }
          var ws = $utils.excel.json_to_sheet(transactions);
          $utils.excel.book_append_sheet(wb, ws, "LoadContainersExp_" + dtstr);
      }
  }
  catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      throw new Error(errorMessage);
  }
  
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: FootprintManager_load_containers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 08/21/2023
  
  const inbound_containers = ($grid.rows.filter(r => r.entity.OrderType.Id === 1)).map(r => r.entity.Id);
  const outbound_containers = ($grid.rows.filter(r => r.entity.OrderType.Id === 2)).map(r => r.entity.Id);
  
  if (inbound_containers.length > 0) {
      $grid.headers.Received.hidden = false;
      $grid.headers.Putaway.hidden = false;
  } else {
      $grid.headers.Received.hidden = true;
      $grid.headers.Putaway.hidden = true;
  };
  
  if (outbound_containers.length > 0) {
      $grid.headers.Available.hidden = false;
      $grid.headers.Picked.hidden = false;
      $grid.headers.Loaded.hidden = false;
  } else {
      $grid.headers.Available.hidden = true;
      $grid.headers.Picked.hidden = true;
      $grid.headers.Loaded.hidden = true;
  };
  
  //Only run if inbound load containers are being requested
  if (inbound_containers.length > 0) {
  
      const receiving_tasks = (await $datasources.LoadContainers.ds_load_container_tasks.get({ loadContainerIds: inbound_containers, statusIds: [2], operationCodeIds: [2] })).result;
      const putaway_tasks = (await $datasources.LoadContainers.ds_load_container_tasks.get({ loadContainerIds: inbound_containers, statusIds: [2], operationCodeIds: [3] })).result;
      const expected_inbound = (await $datasources.LoadContainers.ds_load_container_processed.get({ loadContainerIds: inbound_containers })).result;
  
      const receiving_array = receiving_tasks.map(row => row.Shipment.LoadContainerId);
      const putaway_array = putaway_tasks.map(row => row.Shipment.LoadContainerId);
      const expected_array = expected_inbound.map(row => row.Shipment.LoadContainerId);
  
      for (let row of $grid.rows) {
  
          let loadContainerId = row.entity.Id;
          let loadContainerIndex = -1;
  
          if (row.entity.OrderType.Id === 1) {
  
              let received_total = 0;
              let putaway_total = 0;
              let expected_total = 0;
  
              //Get the total received inventory
              loadContainerIndex = receiving_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  received_total = receiving_tasks[loadContainerIndex].ActualAmount;
              };
  
              //Get the total putaway inventory
              loadContainerIndex = putaway_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  putaway_total = putaway_tasks[loadContainerIndex].ActualAmount;
              };
  
              //Get the total expected inventory
              loadContainerIndex = expected_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  expected_total = expected_inbound[loadContainerIndex].Amount;
              };
  
              if (received_total > 0 && expected_total > 0) {
                  row.cells.Received.displayControl.text = calculatePercentage(received_total, expected_total);
              } else {
                  row.cells.Received.displayControl.text = "0.0%"
              };
  
              if (putaway_total > 0 && expected_total > 0) {
                  row.cells.Putaway.displayControl.text = calculatePercentage(putaway_total, expected_total);
              } else {
                  row.cells.Putaway.displayControl.text = "0.0%"
              };
          };
      };
  };
  
  
  //Only run if outbound load containers are being requested
  if (outbound_containers.length > 0) {
  
      const contents = (await $datasources.LoadContainers.ds_load_container_contents.get({ loadContainerIds: outbound_containers, loadTasks: false })).result;
      const contents_loaded = (await $datasources.LoadContainers.ds_load_container_contents.get({ loadContainerIds: outbound_containers, loadTasks: true })).result;
      const contents_archived = (await $datasources.LoadContainers.ds_load_container_archived_contents.get({ loadContainerIds: outbound_containers })).result;
      const expected = (await $datasources.LoadContainers.ds_load_container_expected.get({ loadContainerIds: outbound_containers })).result;
      const processed = (await $datasources.LoadContainers.ds_load_container_processed.get({ loadContainerIds: outbound_containers })).result;
      const available = (await $datasources.LoadContainers.ds_load_container_expected.get({ loadContainerIds: outbound_containers, statusId: 1, available: true })).result;
  
      const contents_array = contents.map(row => row.LicensePlate.Shipment.LoadContainerId);
      const contents_loaded_array = contents_loaded.map(row => row.LicensePlate.Shipment.LoadContainerId);
      const contents_archived_array = contents_archived.map(row => row.LicensePlate.Shipment.LoadContainerId);
      const expected_array = expected.map(row => row.Shipment.LoadContainerId);
      const processed_array = processed.map(row => row.Shipment.LoadContainerId);
      const available_array = available.map(row => row.Shipment.LoadContainerId);
  
      for (let row of $grid.rows) {
  
          let loadContainerId = row.entity.Id;
          let loadContainerIndex = -1;
  
          if (row.entity.OrderType.Id === 2) {
  
              let picked_content = 0;
              let picked_content_loaded = 0;
              let picked_archived_content = 0;
              let expected_total = 0;
              let processed_total = 0;
              let available_total = 0;
  
              //Get the total picked amount for the load container
              loadContainerIndex = contents_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  picked_content = contents[loadContainerIndex].Amount;
              };
  
              //Get the total picked & loaded amount for the load container
              loadContainerIndex = contents_loaded_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  picked_content_loaded = contents_loaded[loadContainerIndex].Amount;
              };
  
              //Get the total archived amount for the load container, if it's archived we assume it's picked and loaded
              loadContainerIndex = contents_archived_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  picked_archived_content = contents_archived[loadContainerIndex].Amount;
              };
  
              //Get the total expected amount
              loadContainerIndex = expected_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  expected_total = expected[loadContainerIndex].Amount;
              };
  
              //Get the total processed amount
              loadContainerIndex = processed_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  processed_total = processed[loadContainerIndex].Amount;
              };
  
              //Get the total available amount
              loadContainerIndex = available_array.indexOf(loadContainerId)
              if (loadContainerIndex >= 0) {
                  available_total = available[loadContainerIndex].Amount;
              };
  
              let picked_total = picked_content + picked_archived_content
              let loaded_total = picked_content_loaded + picked_archived_content
              let pick_pending = expected_total - picked_total
  
              if (pick_pending < 0) {
                  pick_pending = 0
              };
  
              let total_amount = expected_total;
              let total_available = processed_total + available_total;
  
              if (loaded_total > 0 && total_amount > 0) {
                  row.cells.Loaded.displayControl.text = calculatePercentage(loaded_total, total_amount);
              } else {
                  row.cells.Loaded.displayControl.text = "0.0%"
              };
  
              if (picked_total > 0 && total_amount > 0) {
                  row.cells.Picked.displayControl.text = calculatePercentage(picked_total, total_amount);
              } else {
                  row.cells.Picked.displayControl.text = "0.0%"
              };
  
              if (total_available > 0 && total_amount > 0) {
                  row.cells.Available.displayControl.text = calculatePercentage(total_available, total_amount);
              } else {
                  row.cells.Available.displayControl.text = "0.0%"
              };
          };
      };
  };
  
  function calculatePercentage(a, b) {
      if (b === 0) {
          return "Cannot divide by zero.";
      };
      const percentage = (a / b) * 100;
      return percentage.toFixed(2) + "%";
  };
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_load_containers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'load_containers_grid.on_init');
  //O.Arias - 08/21/2023
  
  if ($utils.isDefined($grid.inParams.orderTypeIds)) {
  
      if ($grid.inParams.orderTypeIds.length === 1) {
  
          if ($grid.inParams.orderTypeIds[0] === 1) {
  
              $grid.headers.Available.hidden = true;
              $grid.headers.Picked.hidden = true;
              $grid.headers.Loaded.hidden = true;
  
              $grid.headers.Received.hidden = false;
              $grid.headers.Putaway.hidden = false;
  
          };
  
          if ($grid.inParams.orderTypeIds[0] === 2) {
  
              $grid.headers.Available.hidden = false;
              $grid.headers.Picked.hidden = false;
              $grid.headers.Loaded.hidden = false;
  
              $grid.headers.Received.hidden = true;
              $grid.headers.Putaway.hidden = true;
  
          };
      };
  };
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'FootprintManager_load_containers_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
